import { useState } from 'react';
import { getId } from '../../utils';

const useDropdown = () => {

  const [ isOpen, setIsOpen ] = useState(false);

  const id = getId();

  return {
    isOpen,
    setIsOpen,
    id,
  };

};

export default useDropdown;
